import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import SEOHead, { injectSchema } from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';

const testimonials = [
  {
    name: '漫迷小陈',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20person%20avatar%20portrait%2C%20friendly%20smile%2C%20simple%20clean%20background%2C%20professional%20headshot%20style%2C%20warm%20lighting&width=200&height=200&seq=avatar-01&orientation=squarish',
    text: '虚空韩漫网的阅读体验真的太棒了！无遮挡下拉式设计让我可以一口气看完几十话，完全沉浸在剧情里。更新速度也很快，每天都有新内容可以追。',
    date: '2026年7月',
  },
  {
    name: '樱花飘落',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20female%20avatar%20portrait%2C%20gentle%20expression%2C%20simple%20clean%20background%2C%20professional%20headshot%20style%2C%20soft%20lighting&width=200&height=200&seq=avatar-02&orientation=squarish',
    text: '作为一个韩漫老粉，试过很多平台，虚空韩漫网是我目前最常用的。界面简洁没有广告打扰，资源也很全，恋爱和奇幻类的漫画特别丰富。',
    date: '2026年8月',
  },
  {
    name: '追更达人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20male%20avatar%20portrait%2C%20confident%20look%2C%20simple%20clean%20background%2C%20professional%20headshot%20style%2C%20bright%20lighting&width=200&height=200&seq=avatar-03&orientation=squarish',
    text: '每天必刷的网站！分类很清晰，找漫画特别方便。而且更新提醒做得很好，追的漫画一更新就能看到，再也不用担心错过新章节了。',
    date: '2026年7月',
  },
  {
    name: '月光下的读者',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20female%20avatar%20portrait%2C%20warm%20smile%2C%20simple%20clean%20background%2C%20professional%20headshot%20style%2C%20natural%20lighting&width=200&height=200&seq=avatar-04&orientation=squarish',
    text: '推荐给了很多朋友！韩国漫画资源真的很全，而且阅读的时候非常流畅，下拉式设计太适合手机看了。希望能一直保持这样的品质。',
    date: '2026年8月',
  },
  {
    name: '剑与魔法',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20male%20avatar%20portrait%2C%20casual%20style%2C%20simple%20clean%20background%2C%20professional%20headshot%20style%2C%20even%20lighting&width=200&height=200&seq=avatar-05&orientation=squarish',
    text: '热血动作类的韩漫在这里都能找到，更新也及时。排行榜功能很实用，通过评分能发现很多高质量的新作品。虚空韩漫网是我每天的精神食粮！',
    date: '2026年6月',
  },
  {
    name: '甜蜜日常',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20female%20avatar%20portrait%2C%20sweet%20expression%2C%20simple%20clean%20background%2C%20professional%20headshot%20style%2C%20warm%20lighting&width=200&height=200&seq=avatar-06&orientation=squarish',
    text: '恋爱类的漫画太甜了！虚空韩漫网的分类做得特别好，我一般直接去恋爱分类区逛，每次都能发现新的宝藏。阅读体验一级棒！',
    date: '2026年8月',
  },
];

const timeline = [
  { year: '2024年', title: '平台诞生', desc: '虚空韩漫网正式上线，致力于为华语读者提供优质的韩国漫画在线阅读服务。' },
  { year: '2025年', title: '资源扩充', desc: '漫画资源突破1000部，涵盖恋爱、奇幻、动作、悬疑等主流类型，日活跃读者突破10万。' },
  { year: '2025年', title: '阅读升级', desc: '推出无遮挡下拉式阅读模式，大幅提升用户阅读体验，获得读者一致好评。' },
  { year: '2026年', title: '持续成长', desc: '漫画资源突破2000部，活跃读者超过100万，成为华语地区领先的韩国漫画在线阅读平台。' },
];

export default function About() {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  useEffect(() => {
    const aboutSchema = {
      '@context': 'https://schema.org',
      '@type': 'AboutPage',
      name: '关于我们 - 虚空韩漫网',
      description: '虚空韩漫网是专业的韩国漫画在线阅读平台，提供无遮挡下拉式韩漫阅读体验。了解我们的品牌故事与发展历程。',
      url: 'https://xukonghanman.com/about',
      isPartOf: {
        '@type': 'WebSite',
        name: '虚空韩漫网',
      },
    };
    injectSchema(aboutSchema);
  }, []);

  return (
    <>
      <SEOHead
        title="关于我们"
        description="了解虚空韩漫网——专业的韩国漫画在线阅读平台。品牌介绍、用户口碑、联系方式。我们致力于提供最好的无遮挡下拉式韩漫阅读体验。"
        keywords="虚空韩漫网,关于我们,韩漫漫画,韩国漫画在线阅读,品牌介绍,联系我们"
        canonicalUrl="https://xukonghanman.com/about"
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <section className="relative w-full h-[360px] md:h-[440px] flex items-center overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=A%20warm%20and%20artistic%20illustration%20of%20a%20cozy%20reading%20corner%20with%20bookshelves%2C%20soft%20amber%20lighting%2C%20abstract%20painterly%20style%2C%20minimalist%20aesthetic%2C%20calm%20and%20inviting%20atmosphere%2C%20no%20text&width=1600&height=900&seq=about-hero-bg&orientation=landscape"
              alt="虚空韩漫网 - 关于我们"
              title="虚空韩漫网 - 关于我们"
              className="absolute inset-0 w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>
            <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6 text-center">
              <h1 className="text-3xl md:text-4xl font-heading font-bold text-white animate-fade-in-up">
                关于我们
              </h1>
              <p className="mt-4 text-base text-white/80 max-w-xl mx-auto animate-fade-in-up-delay-1">
                用心打造最好的韩国漫画在线阅读平台
              </p>
            </div>
          </section>

          <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-8">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
          </section>

          <section className="max-w-[1400px] mx-auto px-4 md:px-6 pb-14 md:pb-20">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
                  品牌介绍
                </h2>
                <div className="mt-6 space-y-4 text-sm text-foreground-600 leading-relaxed">
                  <p>
                    虚空韩漫网成立于2024年，是一个专注于<strong>韩国漫画在线阅读</strong>的专业平台。我们致力于为广大华语读者提供最优质的<strong>韩漫漫画</strong>阅读体验，让每一位漫画爱好者都能在这里找到心仪的作品。
                  </p>
                  <p>
                    我们的核心特色是<strong>无遮挡下拉式韩漫</strong>阅读模式——通过简洁流畅的滚动设计，让读者无需频繁翻页，即可连续沉浸在精彩的漫画故事中。这种创新的阅读方式极大地提升了用户的阅读体验，也成为了虚空韩漫网最受好评的功能之一。
                  </p>
                  <p>
                    目前，虚空韩漫网已收录超过2000部韩国漫画作品，涵盖恋爱浪漫、奇幻冒险、热血动作、都市剧情、搞笑日常、悬疑惊悚、历史古风、BL耽美等丰富类型。我们的内容团队每日更新，确保读者能第一时间追更心仪的作品。
                  </p>
                  <p>
                    我们的使命是：让每一位热爱韩国漫画的读者，都能在虚空韩漫网找到最纯粹、最沉浸的阅读体验。无论您喜欢什么类型的漫画，虚空韩漫网都能满足您的需求。
                  </p>
                </div>
              </div>
              <div className="rounded-lg overflow-hidden aspect-[4/3] bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20modern%20cozy%20digital%20reading%20environment%20with%20tablet%20displaying%20colorful%20webtoon%20art%2C%20warm%20ambient%20lighting%2C%20minimalist%20workspace%2C%20artistic%20illustration%20style%2C%20calm%20and%20creative%20atmosphere&width=1200&height=900&seq=about-brand-img&orientation=landscape"
                  alt="虚空韩漫网品牌形象"
                  title="虚空韩漫网 - 品牌形象"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </section>

          <section className="bg-background-100">
            <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20">
              <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 text-center mb-10">
                发展历程
              </h2>
              <div className="max-w-3xl mx-auto">
                <div className="relative">
                  <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300"></div>
                  {timeline.map((item, index) => (
                    <div key={index} className="relative flex gap-6 pb-10 last:pb-0">
                      <div className="relative z-10 w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center flex-shrink-0">
                        <span className="text-xs font-label font-bold text-white">{index + 1}</span>
                      </div>
                      <div className="pt-1">
                        <div className="flex items-center gap-3">
                          <span className="text-xs font-label font-semibold text-primary-500 bg-primary-100 px-2 py-0.5 rounded-full">
                            {item.year}
                          </span>
                          <h3 className="font-medium text-foreground-900">{item.title}</h3>
                        </div>
                        <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>

          <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20">
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 text-center mb-4">
              用户口碑
            </h2>
            <p className="text-center text-sm text-foreground-500 mb-10 max-w-lg mx-auto">
              来自百万读者的真实评价，是我们不断前行的动力
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {testimonials.map((t, index) => (
                <div key={index} className="bg-background-100 rounded-lg p-5">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                      <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">{t.name}</p>
                      <p className="text-xs text-foreground-500">{t.date}</p>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{t.text}</p>
                  <div className="flex items-center gap-0.5 mt-3">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-secondary-400 text-xs"></i>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="bg-background-100">
            <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20">
              <div className="max-w-2xl mx-auto">
                <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 text-center mb-4">
                  联系我们
                </h2>
                <p className="text-center text-sm text-foreground-500 mb-10">
                  如果您有任何问题或建议，欢迎通过以下方式与我们取得联系
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  <div className="bg-background-50 rounded-lg p-6 text-center">
                    <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-4">
                      <i className="ri-mail-line text-primary-500 text-xl"></i>
                    </div>
                    <h3 className="text-sm font-medium text-foreground-900 mb-2">电子邮箱</h3>
                    <a href="mailto:contact@xukonghanman.com" className="text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200">
                      contact@xukonghanman.com
                    </a>
                  </div>
                  <div className="bg-background-50 rounded-lg p-6 text-center">
                    <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mx-auto mb-4">
                      <i className="ri-wechat-line text-accent-600 text-xl"></i>
                    </div>
                    <h3 className="text-sm font-medium text-foreground-900 mb-2">微信公众号</h3>
                    <p className="text-sm text-foreground-500">
                      虚空韩漫网
                    </p>
                  </div>
                  <div className="bg-background-50 rounded-lg p-6 text-center">
                    <div className="w-12 h-12 rounded-xl bg-secondary-100 flex items-center justify-center mx-auto mb-4">
                      <i className="ri-weibo-line text-secondary-500 text-xl"></i>
                    </div>
                    <h3 className="text-sm font-medium text-foreground-900 mb-2">官方微博</h3>
                    <p className="text-sm text-foreground-500">
                      @虚空韩漫网
                    </p>
                  </div>
                  <div className="bg-background-50 rounded-lg p-6 text-center">
                    <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mx-auto mb-4">
                      <i className="ri-question-answer-line text-accent-600 text-xl"></i>
                    </div>
                    <h3 className="text-sm font-medium text-foreground-900 mb-2">在线反馈</h3>
                    <Link
                      to="/about"
                      className="text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200"
                    >
                      提交反馈
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20 text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
              加入虚空韩漫网
            </h2>
            <p className="mt-4 text-foreground-500 max-w-lg mx-auto text-sm leading-relaxed">
              成为百万读者中的一员，享受最纯粹的<strong>韩国漫画在线阅读</strong>体验。
              无遮挡下拉式阅读，让每一页漫画都触手可及。
            </p>
            <Link
              to="/category/romance"
              className="inline-flex items-center gap-2 mt-8 px-8 py-3.5 rounded-lg bg-primary-500 hover:bg-primary-600 text-white font-medium text-sm transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              立即开始阅读
              <i className="ri-arrow-right-line"></i>
            </Link>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}